import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import {CustomSelect} from '../StyledComp';
import {RECEIPTS_CUSTOM_QUERY} from '../../constants';

const SelectComments = ({t, onChange, value, allowNull, ...props}) => {

  return (
    <CustomSelect
      name="withOrComments"
      onChange={onChange}
      value={value}
      absolute
      {...props}>
      <option disabled value="default">
        {t('withOrComments')}
      </option>
      {allowNull && <option value={RECEIPTS_CUSTOM_QUERY.ReceiptsWithReview}>{t('all')}</option>}
      <option value={RECEIPTS_CUSTOM_QUERY.ReceiptsWithComments}>{t(RECEIPTS_CUSTOM_QUERY.ReceiptsWithComments)}</option>,
      <option value={RECEIPTS_CUSTOM_QUERY.ReceiptsWithReviewWithoutComment}>{t(RECEIPTS_CUSTOM_QUERY.ReceiptsWithReviewWithoutComment)}</option>,
      <option value={RECEIPTS_CUSTOM_QUERY.ReceiptsWithCommentWithoutReply}>{t(RECEIPTS_CUSTOM_QUERY.ReceiptsWithCommentWithoutReply)}</option>,
    </CustomSelect>

  );
};

SelectComments.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  allowNull: PropTypes.bool,
};

SelectComments.defaultProps = {
  allowNull: false,
};

export default withTranslation('merchant')(SelectComments);
